import { Component } from 'react';
import { Affix, Div } from '@platform/base';
class BillHeadInfo extends Component {
    render() {
        let { _pageScope, rightArea, leftArea, showPagination, socketArea, extendButtonArea, ...others } = this.props;
        return <Affix offsetTop={0}>
            <Div areaCode={Div.config.HEADER} className="nc-bill-header-area">
                <div className="header-title-search-area">{_pageScope.props.BillHeadInfo.createBillHeadInfo(others)}</div>
                {/* 自定义区域 */}
                <div className="header-custom-area">
                    {leftArea}
                </div>
                <div className="header-button-area">
                    {/* socket区域 */}
                    {socketArea && socketArea()}
                    {/* 按钮组扩展区域 */}
                    {extendButtonArea && extendButtonArea()}
                    {/* 按钮组区域 */}
                    {rightArea}
                </div>
                <div className="header-cardPagination-area">
                    {showPagination && _pageScope.props.cardPagination.createCardPagination(others)}
                </div>
            </Div>
        </Affix>;
    }
}

export default BillHeadInfo;